import { isCurrentPathPresent } from "utils/common";
import Image from "./Image";
import { useEffect } from "react";

const DecorativeImage = ({
	isDecorativeImage = false,
	decorativeImage = [],
	baseClass,
	fairy: { location, image },
}) => {
	const imageToShow = decorativeImage?.find((decorative) =>
		isCurrentPathPresent(decorative.showOn)
	);
	const imageUrl = isDecorativeImage
		? imageToShow?.decorative.url
		: `${location}/${image}`;
	const altText = isDecorativeImage ? imageToShow?.altText || "" : "";

	useEffect(() => {
		if (imageUrl && image) {
			const link = document.createElement("link");
			link.rel = "preload";
			link.as = "image";
			link.href = imageUrl;
			link.fetchPriority = "high";
			document.head.appendChild(link);
		}
	}, [imageUrl, image])
	
	return (
		<Image
			image={{
				alt: altText,
				baseClass,
				url: imageUrl,
				loading: "eager",
				fetchpriority: "high",
				decoding: "async"
			}}
		/>
	);
};

export default DecorativeImage;
